<template>
  <div>
    <h1>Markup</h1>

    <b-container fluid class="bg-dark">
      <b-row cols="1" cols-sm="2" cols-md="4" cols-lg="6">
        <b-col v-for="asset in selectedAssets" v-bind:key="asset.id">
          <div class="hoverDeleteDiv">
            <b-img-lazy thumbnail fluid :src="asset.URL" :alt="asset.title" class="my-1 myx-2"></b-img-lazy>
            <b-button variant="primary" class="hoverButton top" @click="activate(asset)">Markup</b-button>
          </div>
          <p class="text-light font-weight-lighter">{{asset.title}}</p>
        </b-col>
      </b-row>
    </b-container>
    <asset-header :asset="active" />
    <asset-display :asset="active" />
    <asset-text :asset="active" />
  </div>
</template>

<script>
import store from "@/store";
import { mapGetters } from "vuex";
import AssetDisplay from "@/components/markup/AssetDisplay.vue";
import AssetHeader from "@/components/markup/AssetHeader.vue";
import AssetText from "@/components/markup/AssetText.vue";

export default {
  components: {
    "asset-display": AssetDisplay,
    "asset-header": AssetHeader,
    "asset-text": AssetText
  },
  computed: {
    ...mapGetters({
      selectedAssets: "assets/selected",
      active: "assets/active"
    })
  },
  methods: {
    activate(fbAssetRef) {
      store.dispatch("assets/activate", fbAssetRef);
    }
  }
};
</script>
 
<style>
</style>